import React, { useEffect } from 'react';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { PainSection } from './components/PainSection';
import { ProductIntro } from './components/ProductIntro';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { ValueStack } from './components/ValueStack';
import { AudienceSection } from './components/AudienceSection';
import { Testimonials } from './components/Testimonials';
import { HowItWorks } from './components/HowItWorks';
import { Guarantee } from './components/Guarantee';
import { ClosingBlock } from './components/ClosingBlock';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { FloatingCTA } from './components/FloatingCTA';
interface AppProps {
  showPurchaseNotifications?: boolean;
}
export function App({
  showPurchaseNotifications = true
}: AppProps) {
  useEffect(() => {
    document.title = 'The ESL Survival Vault™';
  }, []);
  return <div className="w-full bg-navy text-white" data-id="element-0" data-mp="3rcj31sdk3h1v">
      <StickyHeader data-id="element-1" data-mp="3rcsulke91w9o" />
      <main data-id="element-2" data-mp="3reltgdimfc74">
        <span id="hero-sentinel" aria-hidden="true" data-id="element-3" data-mp="5yhupa6n3cr" />
        <Hero data-id="element-4" data-mp="5gel8p3rovc" />
        <SocialProofBar data-id="element-5" data-mp="56qjqnmbrsa" />
        <PainSection data-id="element-6" data-mp="2zl3brl12165b" />
        <ProductIntro data-id="element-7" data-mp="2zllijblcf2rh" />
        <VolumesSection data-id="element-8" data-mp="2zmeo498kfm81" />
        <BonusesSection data-id="element-9" data-mp="2zn6actg9w7ln" />
        <ValueStack data-id="element-10" data-mp="33morde4z3yj7" />
        <AudienceSection data-id="element-11" data-mp="33lwy49yumcw3" />
        <Testimonials data-id="element-12" data-mp="33ngiabnml835" />
        <HowItWorks data-id="element-13" data-mp="33orjq4tlm3r3" />
        <Guarantee data-id="element-14" data-mp="38lrpsfqg76i7" />
        <ClosingBlock data-id="element-15" data-mp="38l8f9k34nke7" />
        <FAQ data-id="element-16" data-mp="38l05w267qx7r" />
      </main>
      <Footer data-id="element-17" data-mp="38nunzn1r85y0" />
      <div className="h-[54px] md:hidden" aria-hidden="true" data-id="element-18" data-mp="38o4ct7b2c724" />
      {showPurchaseNotifications && <SocialProofPopup data-id="element-19" data-mp="3dii4ozqinw21" />}
      <FloatingCTA data-id="element-20" data-mp="nw2bc3tnpmq1" />
    </div>;
}